import gql from "graphql-tag";

export const REGISTER_PAYPAL_SUBSCRIPTION = gql`
    mutation registerPayPalSubscription($subscriptionID: String!) {
        registerPayPalSubscription(payPalSubscriptionId: $subscriptionID) {
            ok
            errors
        }
    }
`;
